import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TemplateTypeService, TemplateType } from "../../../../../swaggerServices";
import { takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import { UntypedFormBuilder, Validators, UntypedFormGroup, AbstractControl } from "@angular/forms";
import { TenantConfigService } from "../../../../shared/services/tenant-config.service";
import { ConfigStateService } from "../../../config/config-state.service";
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-update-template-type',
    templateUrl: './update-template-type.component.html',
    styleUrls: ['./update-template-type.component.scss'],
    standalone: false
})
export class UpdateTemplateTypeComponent implements OnInit, OnDestroy {
  taxReturnAlias: string;
  uiConfig: TenantConfigService;

  templateType: TemplateType;
  form: UntypedFormGroup;
  isCreate: boolean = false;
  templateTypeGroupList: object[];

  templateTypeModuleList: object[];

  private unsubscribe = new Subject<void>();
  isProductionMode: boolean;
  subscriptions: Subscription[] = [];

  constructor(
    private formBuilder: UntypedFormBuilder,
    public config: ConfigStateService,
    private templateTypeService: TemplateTypeService,
    private dialogRef: MatDialogRef<UpdateTemplateTypeComponent>,
    @Inject(MAT_DIALOG_DATA) templateType: TemplateType) {
    this.templateType = templateType;
    this.isProductionMode = environment.production;
  }

  get templateTypeName(): AbstractControl {
    return this.form.get('templateTypeName');
  }

  get templateTypeGroup(): AbstractControl {
    return this.form.get('templateTypeGroup');
  }

  get templateTypeOrder(): AbstractControl {
    return this.form.get('templateTypeOrder');
  }

  get signatureRequired(): AbstractControl {
    return this.form.get('signatureRequired');
  }

  get alias(): AbstractControl {
    return this.form.get('alias');
  }
  get otWebSheetDisplayName(): AbstractControl {
    return this.form.get('otWebSheetDisplayName');
  }

  get templateTypeModule(): AbstractControl {
    return this.form.get('templateTypeModule');
  }

  ngOnInit() {
    this.isCreate = !this.templateType;
    this.initForm();
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias
      }));
    this.templateTypeModuleList = [
      { value: 'TAXRETURN', label: this.taxReturnAlias.replace(/\s/g, "").toUpperCase() },
      { value: 'NOTICE', label: 'NOTICE' },
      { value: 'OTHER', label: 'OTHER' }
    ];
    this.templateTypeGroupList = [
      { value: 'taxreturn', label: this.taxReturnAlias },
      { value: 'batch', label: "Batch" },
    ];
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  templateTypeModuleChanged() {
    if (this.templateTypeModule.value !== "TAXRETURN") {
      this.templateTypeGroup.setValue(null);
      this.templateTypeGroup.clearValidators();
      this.templateTypeGroup.updateValueAndValidity();
    } else {
      this.templateTypeGroup.setValidators(Validators.required);
      this.templateTypeGroup.updateValueAndValidity();
    }
  }

  saveTemplateType() {
    const postData = {
      templateType: this.templateTypeName.value,
      templateOrder: this.templateTypeOrder.value,
      templateGroup: this.templateTypeGroup.value,
      signatureRequired: this.signatureRequired.value,
      alias: this.alias.value,
      module: this.templateTypeModule.value,
      otWebSheetDisplayName: this.otWebSheetDisplayName.value
    };

    if (this.isCreate) {
      this.templateTypeService.addTemplateType(postData)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(result => {
          this.dialogRef.close(true);
        }, error => {
          this.dialogRef.close(false);
        });
    } else {
      this.templateTypeService.updateTemplateType(this.templateType.id, postData)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(result => {
          this.dialogRef.close(true);
        }, error => {
          this.dialogRef.close(false);
        });
    }
  }

  onClose() {
    this.dialogRef.close(false);
  }

  formatter(option) {
    return option.label;
  }

  private initForm() {
    this.form = this.formBuilder.group({
      templateTypeName: ['', Validators.required],
      templateTypeOrder: ['', Validators.pattern("^[0-9]*$")],
      templateTypeGroup: [''],
      signatureRequired: [''],
      alias: [''],
      templateTypeModule: ['', Validators.required],
      otWebSheetDisplayName: [''],
    });

    if (!this.isCreate) {
      this.templateTypeName.setValue(this.templateType.templateType);
      if (this.templateType.templateOrder) {
        this.templateTypeOrder.setValue(this.templateType.templateOrder);
      }
      this.signatureRequired.setValue(this.templateType.signatureRequired);
      this.alias.setValue(this.templateType.alias);
      if (this.templateType.otWebSheetDisplayName) {
        this.otWebSheetDisplayName.setValue(this.templateType.otWebSheetDisplayName.toLowerCase());
      }
      if (this.templateType.templateGroup) {
        this.templateTypeGroup.setValue(this.templateType.templateGroup.toLowerCase());
      }
      if (this.templateType.module) {
        this.templateTypeModule.setValue(this.templateType.module.toUpperCase());
      }
    }
    this.templateTypeModuleChanged();
  }


}
